import { render, staticRenderFns } from "./CheckboxAudienceRequestPresentation.vue?vue&type=template&id=028c839b&scoped=true&"
import script from "./CheckboxAudienceRequestPresentation.vue?vue&type=script&lang=js&"
export * from "./CheckboxAudienceRequestPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c839b",
  null
  
)

export default component.exports